import React from 'react';
import {
  Box,
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { ALL_SOURCES } from './knowledgeBaseUtils';

const KnowledgeFilters = ({
  search,
  source,
  sources,
  hasActiveFilters,
  onSearchChange,
  onSourceChange,
  onClear,
}) => (
  <Box
    display='flex'
    flexDirection={{ xs: 'column', md: 'row' }}
    alignItems={{ xs: 'stretch', md: 'center' }}
    gap={1.5}
    mb={2.5}
  >
    <TextField
      size='small'
      placeholder='Search client knowledge'
      value={search}
      onChange={(event) => onSearchChange(event.target.value)}
      sx={{ flex: 1, minWidth: 0 }}
      inputProps={{ 'aria-label': 'Search client knowledge' }}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <SearchIcon fontSize='small' color='action' />
          </InputAdornment>
        ),
      }}
    />
    <FormControl size='small' sx={{ minWidth: { xs: '100%', md: 180 } }}>
      <InputLabel id='kb-source-label'>Source</InputLabel>
      <Select
        labelId='kb-source-label'
        label='Source'
        value={source}
        onChange={(event) => onSourceChange(event.target.value)}
        inputProps={{ 'aria-label': 'Filter by source' }}
      >
        <MenuItem value={ALL_SOURCES}>All Sources</MenuItem>
        {sources.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    <Button
      variant='outlined'
      color='inherit'
      onClick={onClear}
      disabled={!hasActiveFilters}
      sx={{ textTransform: 'none', px: 2.5, width: { xs: '100%', md: 'auto' } }}
    >
      Clear
    </Button>
  </Box>
);

export default KnowledgeFilters;
